/**
 * Get component name from lazy component import function.
 *
 * ```
 * () => import('somePath/SomeComponent.tsx')
 * () => import('somePath/SomeComponent/index.tsx')
 * ```
 * and we want to extract "someComponent" from it.
 *
 * @param factoryFn - dialog factory function
 * @returns name of component
 */

export function getComponentNameFromImportFactory(factoryFn: () => unknown) {
  const pathComponents = factoryFn.toString().split('/')
  const name = pathComponents.pop()?.split('.')[0]
  if (name !== 'index') {
    return name
  }
  return pathComponents.pop()
}
